import {InterfaceEventsEnum, trackInterfaceEvent} from '../tracking';

const hashedArrowShortcuts: ReadonlyArray<string> = Object.freeze(['-->', '<--', '<->']);

export function trackCharacterShortcutReplaceEvent(shortcutText: string) {
  if (!hashedArrowShortcuts.includes(shortcutText)) {
    return;
  }

  trackInterfaceEvent(InterfaceEventsEnum.COMPOSER_INSERT, {
    item_type: 'hashed_arrow',
  });
}
